import { fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import SearchContentTypes from 'SalesContentIndexUI/data/constants/SearchContentTypes';
export function search(searchQueryRecord) {
  return http.post('salescontentsearch/v2/search', {
    data: searchQueryRecord.toJS()
  }).then(fromJS);
}
export const GET_FOLDERS = registerQuery({
  fieldName: 'getFolders',
  fetcher: async () => {
    const response = await http.post('salescontentsearch/v2/search', {
      data: {
        query: '',
        contentType: SearchContentTypes.DOCUMENTS_FOLDER,
        limit: 1000
      }
    });
    return response;
  }
});